import { Banner } from '@shopify/polaris';
import TranslationClickListener from 'components/translation-click-listener/TranslationClickListener';
import useOpenHelpCenter from 'hooks/help-center/useOpenHelpCenter';
import { useScriptTags } from 'hooks/script-tag/useScriptTags';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from 'redux/hooks';
import { currentEcomSelector } from 'redux/slices/ecoms-slice';
import { goToThemesEditor } from 'utils/app-embed/appsEmbedIntegrationUtils';

const ScriptTagsBanner = () => {
    const { t } = useTranslation();
    const ecom = useAppSelector(currentEcomSelector);
    const {
        scriptTags,
        isActionLoading,
        isSuccess,
        setIsSuccess,
        showIntegrationBanner,
        setShowIntegrationBanner,
        handleAction,
    } = useScriptTags();

    const openHelpCenter = useOpenHelpCenter(15285769, 'article', 'script_tags_banner');

    if (showIntegrationBanner) {
        return (
            <Banner
                tone="warning"
                title={t('DASHBOARD.SCRIPT_TAGS.INTEGRATION_BANNER.TITLE')}
                action={{
                    content: t('DASHBOARD.SCRIPT_TAGS.INTEGRATION_BANNER.BUTTON'),
                    onAction: () => {
                        goToThemesEditor();
                        setShowIntegrationBanner(false);
                        setIsSuccess(true);
                    },
                }}
            >
                <TranslationClickListener id="open_help_center" action={openHelpCenter}>
                    <div
                        dangerouslySetInnerHTML={{
                            __html: t('DASHBOARD.SCRIPT_TAGS.INTEGRATION_BANNER.DESCRIPTION'),
                        }}
                    />
                </TranslationClickListener>
            </Banner>
        );
    }

    if (isSuccess) {
        return <Banner tone="success" title={t('DASHBOARD.SCRIPT_TAGS.SUCCESS')} />;
    }

    if (!scriptTags.length) return null;

    return (
        <Banner
            tone="warning"
            title={t('DASHBOARD.SCRIPT_TAGS.REMOVE_SCRIPT_TAG_BANNER.TITLE')}
            action={{
                content: t('DASHBOARD.SCRIPT_TAGS.REMOVE_SCRIPT_TAG_BANNER.DELETE'),
                onAction: () => handleAction(ecom.uniqueId),
                loading: isActionLoading,
            }}
        >
            <div
                dangerouslySetInnerHTML={{
                    __html: t('DASHBOARD.SCRIPT_TAGS.REMOVE_SCRIPT_TAG_BANNER.DESCRIPTION'),
                }}
            />
        </Banner>
    );
};

export default ScriptTagsBanner;
